import React from "react"
import { ReactBricks } from "react-bricks/frontend"
import config from "../react-bricks/config"

type WrapRootProps = {
    children: React.ReactNode
}

const WrapRoot = ({ children }: WrapRootProps) => {
    return <ReactBricks {...config}>{children}</ReactBricks>
}

export default WrapRoot
